module.exports = __webpack_public_path__ + "static/gostin2-dc009e6b6c1479e796323f9a24180d7a.webp";